import React from "react";
import { Link } from "react-router-dom";

const linkStyle = { color: "inherit", textDecoration: "none" };
const sep = <span style={{ margin: "0 8px", opacity: 0.7 }}>•</span>;

export default function FooterLinks() {
  return (
    <div
      style={{
        width: "100%",
        boxSizing: "border-box",
        padding: "14px 12px 18px",
        textAlign: "center",
        fontSize: 12,
        color: "rgba(200, 210, 255, 0.55)",
        lineHeight: 1.9,
      }}
    >
      <Link to="/about" style={linkStyle}>About</Link>
      {sep}
      <Link to="/contact" style={linkStyle}>Contact</Link>
      {sep}
      <Link to="/guides" style={linkStyle}>Guides</Link>
      {sep}
      <Link to="/blog" style={linkStyle}>Blog</Link>
      {sep}
      <Link to="/privacy" style={linkStyle}>Privacy</Link>
      {sep}
      <Link to="/terms" style={linkStyle}>Terms</Link>
    </div>
  );
}
